<template>
    <div class="course_main">
        <div v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><img src="@/Images/icon_back.png"/></div>
            <div class="title"></div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <div class="content">
            <div class="des">
                Hi,欢迎加入小花生英语启蒙Program ！我是小花生班主任，在使用期间，有任何问题或建议，欢迎微信联系班主任哦~
                <br/><br/>
                长按下图保存，进入微信识别，添加班主任微信
            </div>
            <div class="icon_qrcode">
                <img src="@/Images/icon_qrcode.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        methods: {
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (vPlatform === 4) {
                    window.note.changeStatusStyle(status);
                }
            },
        },
        beforeCreate() {
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    .navigation {
        position: fixed;
        width: 100%;
        z-index: 998;
        background-color: white;
    }

    .navigation .left img {
        width: 25px;
        height: 22px;
    }

    .course_main {
        background-color: white;
        min-height: 100vmax;
    }
    .course_main .left {
        color: #333333;
    }
    .course_main .title {
        color: #333333;
        font-size: 18px;
    }
    .content .des {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 20px;
        color: #333333;
        font-size: 16px;
    }
    .icon_qrcode {

    }
    .icon_qrcode img {
        width: 70vmin;
        margin-left: 15vmin;
        margin-top: 30px;
    }

</style>